import { render, staticRenderFns } from "./add_consultation.vue?vue&type=template&id=36cc8860&"
import script from "./add_consultation.vue?vue&type=script&lang=js&"
export * from "./add_consultation.vue?vue&type=script&lang=js&"
import style0 from "./add_consultation.vue?vue&type=style&index=0&id=36cc8860&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports